import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class NewstandIntegrationSetupError extends CodedError {
  static get errorName() {
    return errorCodes.newstandIntegrationSetupError.code;
  }

  constructor(message: string = errorCodes.newstandIntegrationSetupError.message) {
    super(message);
    this.code = errorCodes.newstandIntegrationSetupError.code;
    this.message = `${message} ${errorCodes.newstandIntegrationSetupError.code}`;
    this.name = errorCodes.newstandIntegrationSetupError.name;
  }
}
